import { render, staticRenderFns } from "./Suscriptions.vue?vue&type=template&id=366c11fc&scoped=true"
import script from "./Suscriptions.vue?vue&type=script&lang=js"
export * from "./Suscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c11fc",
  null
  
)

export default component.exports